<script>
import DsfVerticalSubTableCellContent from "./verticalSubTableCellContent.vue";
export default dsf.component({
  name: "DsfVerticalSubTableColumn",
  inheritAttrs: false,
  mixins: [$mixins.layout],
  ctrlCaption: "子表列",
  inject: ["$verticalSubTable"],
  props: {
    column: {
      type: Object,
      default() {
        return {
          label: "",
          children: [],
        };
      },
    },
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    isHeadCol: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableWidth: 0,
      editable: false,
    };
  },
  created() {},
  computed: {
    ownerTable() {
      let parent = this.$parent;
      while (parent.$options.name != "DsfVerticalSubTable") {
        parent = parent.$parent;
      }
      return parent;
    },
    bodyWidth() {
      return this.elTable.bodyWidth;
    },
    elTable() {
      return this.$parent;
    },
  },
  beforeMount() {},
  mounted() {},
  methods: {
    getWidth(column) {
      let width = column.width;
      let totalWidth = this.ownerTable.tableWidth;
      if (totalWidth) {
        if (dsf.type(width) == "string" && width && width.endsWith("%")) {
          let w = parseFloat(width.replace("%", "")) / 100;
          let indexColumnWidth = this.ownerTable.isShowIndexColumn ? 60 : 0;
          let operateColumnWidth = this.ownerTable.isShowOperateColumn
            ? 130
            : 0;
          let tw = totalWidth - indexColumnWidth - operateColumnWidth;
          width = parseFloat(tw) * w;
        }
      }
      return width;
    },
  },
  beforeDestroy() {
    console.log("col", "beforeDestroy");
  },
  updated() {},
  render(h) {
    return renderHeader.call(this, h, this.column, this.$vnode.data.key);
  },
});

function renderHeader(h, column, key) {
  const _this = this;
  let child = [];
  let scopedSlots = null;
  if (column.children && column.children.length > 0) {
    child = column.children.map((c, i) => {
      return renderHeader.call(_this, h, c);
    });
  } else {
    child = this.$slots[column.columnId];
    scopedSlots = {
      header(scope) {
        return h("span", column.label);
      },
      default(scope) {
        if (!_this.isHeadCol) {
          const key = scope.row._rowId;
          scope.tableRow = scope.row;
          scope.row = _this.column.rowValue;
          scope.$index = _this.column.rowValue.$index;
          return _this.$scopedSlots[key] && _this.$scopedSlots[key](scope);
        } else {
          return h("span", scope.row["_" + column.label]);
        }
      },
    };
  }
  let props = { ...column, type: column.type == "expand" ? "expand" : "" };
  const data = {
    key: key,
    props: { ...props },
    scope: "scope",
    scopedSlots: scopedSlots,
    attrs: {
      "class-name": column.columnId,
      columnKey: column.columnId,
      ...this.$attrs,
      minWidth: props.minWidth,
      width: this.getWidth(column),
      "column-id": column.columnId,
      // sortable: this.sortable
    },
  };
  if (this.ownerTable) {
    return h("el-table-column", data, child);
  }
  return null;
}
</script>
